export type GetComponentProjectResponse = {
  cmpPjtInfo: CmpPjtInfo;
  stkhldrs: GetStkhldrs[];
  relatedIfPjts: RelatedIfPjts[];
  cpntAttrStatus: CpntAttrStatus;
  stupTaskCtgries: GetStupTaskCtgries[];
  stupTasks: GetStupTasks[];
  stupTckts: StupTckts[];
  mmTxt: string;
  mmTxtUpdateDateTime: string;
};
export type CmpPjtInfo = {
  cpntPjtTypeCd: string;
  cpntPjtTypeName: string;
  pjtName: string;
  pjtSts: string;
  pjtStsDsplyName: string;
  dipByRgn: string;
  rootCpntId: string;
  cpntId: string;
  cpntName: string;
  cpntPrtclCtgryTypeCd: string;
  inOutTypeCd: string;
  inOutTypeName: string;
  prtcolTypeCd: string;
  prtcolTypeName: string;
  ptnrId: string;
  ptnrName: string;
  delPjtFlg: string;
  stgOnlyFlg: string;
  othrStgStupFlg: string;
  stgSchedDplymntDate: string;
  prdSchedDplymntDate: string;
  stgIfdDplymntPsblFlg: string;
  prdIfdDplymntPsblFlg: string;
  reqTskSlctdFlg: string;
  updateDateTime: string;
};
export type GetStkhldrs = {
  stkhldrId: string;
  primFlg: string;
  roleCd: string;
  roleName: string;
  teamCd: string;
  userId: string;
  userName: string;
  mlAdrs: string;
  stkhldrNote: string;
};
export type RelatedIfPjts = {
  pjtId: string;
  pjtName: string;
  stgDplymntPlnDate: string;
  prdDplymntPlnDate: string;
};
export type CpntAttrStatus = {
  dsgnTcktId: string;
  dsgnSts: string;
  dsgnStsDsplyName: string;
  stgDplymntTcktId: string;
  stgDplymntSts: string;
  stgDplymntStsDsplyName: string;
  prdDplymntTcktId: string;
  prdDplymntSts: string;
  prdDplymntStsDsplyName: string;
};
export type GetStupTaskCtgries = {
  stupTaskCtgryId: string;
  cpntPrtclCtgryTypeCd: string;
  cpntPrtclCtgryTypeName: string;
  prtclTypeCd: string;
  prtclTypeName: string;
  necFlg: string;
  updateDateTime: string;
};
export type GetStupTasks = {
  stupTaskCtgryId: string;
  cpntPrtclCtgryTypeCd: string;
  cpntPrtclCtgryTypeName: string;
  prtclTypeCd: string;
  prtclTypeName: string;
  dsgnInfo: string;
  stupTaskList: StupTaskList[];
};
export type StupTaskList = {
  stupTaskId: string;
  taskDesc: string;
  roleCd: string;
  necFlg: string;
  updateDateTime: string;
};
export type StupTckts = {
  envrnmntId: string;
  roleCd: string;
  tcktId: string;
  tcktSts: string;
  tcktStsDsplyName: string;
};
